import { Routes } from '@angular/router';

import { PermissionsList } from '../../shared/common/PermissionList';
import { AuthorizationGuard } from '../../core/auth/guards/authorization.guard';



export const passengersRoutes: Routes = [
  {
    path: 'passengers',
    loadComponent: () => import('./passengers.component').then(m => m.PassengersComponent),
    children: [
      {
        path: 'students',
        loadComponent: () => import('./pages/students-pages/students/students.component').then(m => m.StudentsComponent),
        title: 'Students | ADROIT',
        data: {
          PermissionPageName: [
            PermissionsList[PermissionsList.ClientStudentsView],
          ],
        },
        canActivate: [AuthorizationGuard],
      },
      {
        path: 'guardians-app-users',
        loadComponent: () => import('./pages/guardians-pages/guardians/guardians.component').then(m => m.GuardiansComponent),
        title: 'Guardians App User | ADROIT',
        data: {
          PermissionPageName: [
            PermissionsList[PermissionsList.ClientGuardiansView],
          ],
        },
        canActivate: [AuthorizationGuard],
      },
    ],
  },
];
